import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ResendActivation.css';

const ResendActivation = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Please enter your email address');
      setIsError(true);
      setIsSuccess(false);
      return;
    }

    setLoading(true);
    setMessage('');
    setIsError(false);
    setIsSuccess(false);

    try {
      const response = await fetch('https://nlngraclub.com/nlnapi/resend_activation.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ email: email })
      });

      const data = await response.json();

      if (data.success) {
        setMessage(data.message);
        setIsSuccess(true);
        setIsError(false);
      } else {
        setMessage(data.message);
        setIsError(true);
        setIsSuccess(false);
      }
    } catch (error) {
      console.error('Resend activation error:', error);
      setMessage('Network error. Please try again.');
      setIsError(true);
      setIsSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div 
      className="resend-activation-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="resend-container">
        <div className="resend-card">
          <div className="resend-header">
            <div className="header-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h2>Resend Activation Email</h2>
            <p>Enter your email address to receive a new activation link</p>
          </div>

          {message && (
            <motion.div 
              className={`alert-message ${isError ? 'alert-error' : 'alert-success'}`}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <i className={`fas ${isError ? 'fa-exclamation-triangle' : 'fa-check-circle'}`}></i>
              <span>{message}</span>
            </motion.div>
          )}

          <form onSubmit={handleSubmit} className="resend-form">
            <div className="form-group">
              <label htmlFor="email">
                <i className="fas fa-envelope"></i>
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                disabled={loading}
                required
              />
            </div>

            <button 
              type="submit" 
              className="resend-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner"></div>
                  Sending...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Resend Activation Email
                </>
              )}
            </button>
          </form>

          <div className="resend-footer">
            <Link to="/login">
              <i className="fas fa-arrow-left"></i> Back to Login
            </Link>
            <Link to="/register">
              Don't have an account? Register
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ResendActivation;